/**
 * Utilidades de fecha para PGastos
 * Evita el desfase de zona horaria (UTC medianoche vs hora local)
 */

/**
 * Parsea una fecha en formato YYYY-MM-DD o ISO a un objeto Date local
 * asegurando que no se reste un día por conversión UTC.
 * @param {string|Date} dateInput 
 * @returns {Date}
 */
export const parseLocalDate = (dateInput) => {
  if (!dateInput) return new Date();
  if (dateInput instanceof Date) return dateInput;

  let dateString = String(dateInput);

  // Si contiene T, extraer solo la parte de la fecha (YYYY-MM-DD)
  if (dateString.includes('T')) {
    dateString = dateString.split('T')[0];
  }

  const parts = dateString.split('-');
  if (parts.length === 3) {
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Meses en JS son 0-indexados
    const day = parseInt(parts[2], 10);

    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      return new Date(year, month, day, 12, 0, 0); // Mediodía local para total seguridad contra DST
    }
  }

  const fallback = new Date(dateInput);
  return isNaN(fallback.getTime()) ? new Date() : fallback;
};

/**
 * Formatea una fecha local a string en español (es-MX)
 * @param {string|Date} dateInput 
 * @param {Intl.DateTimeFormatOptions} options 
 * @returns {string}
 */
export const formatLocalDate = (dateInput, options = { day: 'numeric', month: 'short' }) => {
  const d = parseLocalDate(dateInput);
  return d.toLocaleDateString('es-MX', options);
};

/**
 * Retorna fecha local actual en formato YYYY-MM-DD
 * @returns {string}
 */
export const getTodayLocalDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
